import { RootState } from '../store';
export const userFeedback = (state: RootState) => state.userFeedback;
